import { render } from "./FacilityOwnershipTerms.vue?vue&type=template&id=10a7540f&scoped=true"
import script from "./FacilityOwnershipTerms.vue?vue&type=script&lang=js"
export * from "./FacilityOwnershipTerms.vue?vue&type=script&lang=js"

import "./FacilityOwnershipTerms.vue?vue&type=style&index=0&id=10a7540f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a7540f"]])

export default __exports__